import { useState, useEffect } from 'react'

import { getCustomerAPI } from '~/utils/api'
import HTTPError from '~/utils/http-error'
import { reportGroupedError } from '~/utils/logger'

const initializeFreedomPayHpcSession = async (): Promise<
  Record<string, any>
> => {
  try {
    const resp = await getCustomerAPI().initializeFreedomPayHpcSession()
    if (resp.ok) return resp.json()

    throw new HTTPError(
      'failed: initializeFreedomPayHpcSession',
      resp,
      await resp.text(),
    )
  } catch (error) {
    reportGroupedError('initializeFreedomPayHpcSession', error)
    throw error
  }
}

const useFreedomPayHpcSessionKey = (): [string | null, boolean, () => void] => {
  const [sessionKey, setSessionKey] = useState(null)
  const [loading, setLoading] = useState(true)

  const setFreedomPayHpcSessionKey = async () => {
    try {
      const { data } = await initializeFreedomPayHpcSession()
      setSessionKey(data.session_key)
      setLoading(false)
    } catch (error) {
      reportGroupedError('useFreedomPayHpcSessionKey', error)
      throw error
    }
  }

  const reloadSessionKey = () => {
    setSessionKey(null)
    setLoading(true)
    setFreedomPayHpcSessionKey()
  }

  useEffect(() => {
    setFreedomPayHpcSessionKey()
  }, [])

  return [sessionKey, loading, reloadSessionKey]
}

export default useFreedomPayHpcSessionKey
